import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import * as projectOrderCrud from '../../../../crud/projectOrder.crud';
import { notificationUniqueTagsFilterV3 } from "../../../../store/helpers/FilterHelper";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import moment from 'moment';


class PackagedProjectsRegisterPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notifications: null,
        };
    }
    componentDidMount() {
        this.fetchPackagedProjects();
    }

    fetchPackagedProjects = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: notifications } = await projectOrderCrud.getProjectOrderPackagedList(contractid);
            this.setState({ notifications });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }
    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            this.props.navigate(this.props.workflowsQA['72'].paths.basePath + data.projectorderid);
        }
    }

    calculateUrl = (rowData) => {
        return this.props.workflowsQA['72'].paths.basePath + rowData.projectorderid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = cellInfo.data.showtasknotification === 1 ? 'success' : 'secondary';
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.status });
    }

    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }
        const { projectOrderFields } = this.props;

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
        ];

        if (projectOrderFields.ProjectRelation.visible) {
            columns.push(
                { resource: "CONTRACT.FIELD.LINKED_PROJECT_NAME", dataField: "linkedprojectname" },
                { resource: "CONTRACT.FIELD.LINKED_PROJECT_CODE", dataField: "linkedprojectcode" },
            );
        }
        if (projectOrderFields.ProjectOrderNumber.visible) {
            columns.push(
                { caption: projectOrderFields.ProjectOrderNumber.label, dataField: "projectordernumber" },
            );
        }
        if (projectOrderFields.PurchaseOrderValue.visible) {
            columns.push(
                { caption: projectOrderFields.PurchaseOrderValue.label, dataField: "purchaseordervalue", dataType: 'currency', currencyCode: this.props.contract.currency },
            );
        }

        columns.push(
            { resource: "CONTRACT.FIELD.ORIGINAL_PRICE", dataField: "originalprice", dataType: 'currency', currencyCode: this.props.contract.currency },
            { resource: "CONTRACT.FIELD.CURRENT_PRICE", dataField: "currentprice", dataType: 'currency', currencyCode: this.props.contract.currency },
            { resource: "CONTRACT.FIELD.COST_FORECAST", dataField: "costforecast", dataType: 'currency', currencyCode: this.props.contract.currency },
            { resource: "CONTRACT.FIELD.TOTAL_CERTIFIED", dataField: "totalcertified", dataType: 'currency', currencyCode: this.props.contract.currency },
            { resource: "CERTIFIED_COMPLETION_DATE", dataField: "certifiedcompletiondate", dataType: 'date' },
            { resource: "CONTRACT.FIELD.NOTES", dataField: "notes" },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
        );
        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="6"
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="projectorderid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

export default withListPageProps(PackagedProjectsRegisterPage);
